export const storeLocatorSelectorWithFallback = (state) =>
  state.storeLocator || {};
